import BaseAPI from '@/services/api/internal/tools/baseAPI';

const ActionPlansAPI = new BaseAPI({
  url: `${process.env.MYPREDITY_BASE_URI}/actionplans`,
});

export default ActionPlansAPI;
